import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { IconButton } from "@material-ui/core";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import Swal from "sweetalert2";

import "./NavBar.scss";
import Hamburger_icon from "../../assets/images/icons/Hamburger_icon.png";
import User_white_icon from "../../assets/images/icons/User_white_icon.png";
import Group_white_icon from "../../assets/images/icons/Group_white_icon.png";
import Back_icon from "../../assets/images/icons/Back_icon.png";
import Calendar_white_icon from "../../assets/images/icons/Calendar_white_icon.png";
import Message_white_icon from "../../assets/images/icons/Message_white_icon.png";
import Building_white_icon from "../../assets/images/icons/Building_white_icon.png";
import Dollar_white_icon from "../../assets/images/icons/Dollar_white_icon.png";
import Graph_white_icon from "../../assets/images/icons/Graph_white_icon.png";
import Speaker_white_icon from "../../assets/images/icons/Speaker_white_icon.png";
// import Recorder_white_icon from "../../assets/images/icons/Recorder_white_icon.png";
import Settings_white_icon from "../../assets/images/icons/Settings_white_icon.png";
import Logout_white_icon from "../../assets/images/icons/Logout_white_icon.png";
import sikkaPrimeLogoWhite from "../../assets/images/appLogo/sikkaPrimeLogoWhite.png";
import { CANADA, logout, store, trackActivity, VETERINARY } from "../../utils";
import { eventName, eventType } from "../../tracking/Tracking";
import IntroVideoModal from "../videos/introVideos/IntroVideoModal";
import AdminModal from "../../pages/Login/AdminModal";
import { proceedLogin } from "../../pages/Login/loginHelpers";
import { addDataToStore } from "../../state/actions";

const patientsMenu = [
    { title: "Patient List", img: Group_white_icon, path: "/" },
    { title: "Appointments", img: Calendar_white_icon, path: "appointments" },
    { title: "Messages", img: Message_white_icon, path: "messages" },
];
const practicesMenu = [
    {
        title: "Eligibility Requests",
        img: "https://s3.amazonaws.com/dpm2.0/Icons/CheckReceipt_White.svg",
        path: "eligibility-requests",
    },
    {
        title: "Account Receivables",
        img: Dollar_white_icon,
        path: "accountReceivables",
    },
    {
        title: "Morning Meeting Lite",
        img: Graph_white_icon,
        path: "morning-meeting-lite",
    },
    { title: "Campaigns", img: Speaker_white_icon, path: "campaigns" },
];

const MenuTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
    [`& .MuiTooltip-tooltip`]: {
        fontSize: "16px",
    },
});

const logoutComp = (
    <div className="img-div">
        <img alt="Logout" src={Logout_white_icon} />
    </div>
);

const switchAccComp = (
    <div className="img-div">
        <img
            alt="Switch Account"
            src="https://s3.us-east-1.amazonaws.com/dpm2.0/Icons/SwitchAccount.svg"
        />
    </div>
);

const resourcesEl = (
    <div className="img-div">
        <img
            alt="Resources"
            src={
                "https://s3.amazonaws.com/dpm2.0/Icons/DocumentOutline_White.svg"
            }
        />
    </div>
);

const settingsImg = <img alt="Settings" src={Settings_white_icon} />;

function NavBar({ userInfo, addDataToStore, sikkaAdmin }) {
    const [expandMenu, setExpandMenu] = useState(false);
    const [activeSection, setActiveSection] = useState("Patients");
    const [showVideoModal, setShowVideoModal] = useState(false);
    const [openAdminModal, setOpenAdminModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleExpandMenu = () => {
        setExpandMenu(!expandMenu);
    };

    const handleLogout = () => {
        Swal.fire({
            text: "Are you sure you want to logout?",
            showConfirmButton: true,
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Yes, I am sure ",
            cancelButtonText: "Cancel",
            customClass: {
                confirmButton: "primary-btn",
                cancelButton: "secondary-btn",
            },
        }).then(async (res) => {
            if (res.isConfirmed) {
                logout();
            }
        });
    };

    const handleSwitchAccount = () => {
        setOpenAdminModal(true);
    };

    const combinedStore = (type, data) => {
        store.set("session", type, data);
        addDataToStore(type, data);
    };

    const proceedToSwitchAccountPage = (selectedRow) => {
        setLoading(true);
        proceedLogin(
            combinedStore,
            selectedRow,
            setLoading,
            null,
            null,
            null,
            navigate,
            true
        );
    };

    return (
        <div className={`NavBar${expandMenu ? " expanded-menu" : ""}`}>
            {expandMenu ? (
                <div className="d-flex align-items-center">
                    <IconButton onClick={handleExpandMenu}>
                        <img src={Back_icon} alt="Collapse Menu" />
                    </IconButton>
                    <img
                        alt="Sikka Prime"
                        src={sikkaPrimeLogoWhite}
                        className="sikkaPrimeLogo-white"
                    />
                </div>
            ) : (
                <div className="w-100 d-flex align-items-center justify-content-center">
                    <IconButton onClick={handleExpandMenu}>
                        <img alt="Expand Menu" src={Hamburger_icon} />
                    </IconButton>
                </div>
            )}

            <div style={{ marginTop: 36 }}>
                <div>
                    {expandMenu && (
                        <div
                            className={`navbar-section-header${
                                activeSection === "Patients" ? " active" : ""
                            }`}
                        >
                            <div className="img-div">
                                <img alt="" src={User_white_icon} />
                            </div>

                            <div>Patients</div>
                        </div>
                    )}
                    <div className="navbar-menu">
                        {patientsMenu.map((i) => (
                            <NavLink
                                className={`navbar-menu-item${
                                    expandMenu
                                        ? " patients-section-expanded"
                                        : ""
                                }`}
                                key={i.path}
                                to={i.path}
                                onClick={() => setActiveSection("Patients")}
                            >
                                {expandMenu ? (
                                    <>
                                        <div className="img-div">
                                            <img alt={i.title} src={i.img} />
                                        </div>
                                        <div>{i.title}</div>
                                    </>
                                ) : (
                                    <MenuTooltip
                                        title={i.title}
                                        placement="right"
                                    >
                                        <div className="img-div">
                                            <img alt={i.title} src={i.img} />
                                        </div>
                                    </MenuTooltip>
                                )}
                            </NavLink>
                        ))}
                    </div>
                </div>

                {expandMenu && <div className="navbar-separator"></div>}

                <div style={{ marginTop: 12 }}>
                    {expandMenu && (
                        <div
                            className={`navbar-section-header${
                                activeSection === "Practices" ? " active" : ""
                            }`}
                        >
                            <div className="img-div">
                                <img alt="" src={Building_white_icon} />
                            </div>
                            <div>Practices</div>
                        </div>
                    )}
                    <div className="navbar-menu">
                        {practicesMenu.map((i) => {
                            // if (
                            //     // only display AR for PASSION ACCOUNT
                            //     i.title === "Account Receivables" &&
                            //     userInfo.masterId !== "D43304" &&
                            //     userInfo.masterId !== "D43386"
                            // )
                            //     return <></>;
                            if (
                                // Hide Eligibility Requests for Canadian users and VET version
                                i.title === "Eligibility Requests" &&
                                (userInfo.domainName === VETERINARY ||
                                    userInfo.country === CANADA)
                            )
                                return <></>;
                            return (
                                <NavLink
                                    className={`navbar-menu-item ${
                                        expandMenu
                                            ? " practices-section-expanded"
                                            : ""
                                    }`}
                                    key={i.path}
                                    to={i.path}
                                    onClick={() =>
                                        setActiveSection("Practices")
                                    }
                                >
                                    {expandMenu ? (
                                        <>
                                            <div className="img-div">
                                                <img
                                                    alt={i.title}
                                                    src={i.img}
                                                />
                                            </div>
                                            <div>{i.title}</div>
                                        </>
                                    ) : (
                                        <MenuTooltip
                                            title={i.title}
                                            placement="right"
                                        >
                                            <div className="img-div">
                                                <img
                                                    alt={i.title}
                                                    src={i.img}
                                                />
                                            </div>
                                        </MenuTooltip>
                                    )}
                                </NavLink>
                            );
                        })}
                    </div>
                </div>

                {expandMenu && <div className="navbar-separator"></div>}

                <div style={{ marginTop: 12 }}>
                    <div className="navbar-menu">
                        <NavLink
                            className={`navbar-menu-item ${
                                expandMenu ? " practices-section-expanded" : ""
                            }`}
                            to="settings"
                            onClick={() => setActiveSection("")}
                        >
                            {expandMenu ? (
                                <>
                                    <div className="img-div">{settingsImg}</div>
                                    <div>Settings</div>
                                </>
                            ) : (
                                <MenuTooltip title="Settings" placement="right">
                                    <div className="img-div">{settingsImg}</div>
                                </MenuTooltip>
                            )}
                        </NavLink>

                        <NavLink
                            className={`navbar-menu-item ${
                                expandMenu ? " practices-section-expanded" : ""
                            }`}
                            to="resource"
                            onClick={() => setActiveSection("")}
                        >
                            {expandMenu ? (
                                <>
                                    {resourcesEl}
                                    <div>Resources</div>
                                </>
                            ) : (
                                <MenuTooltip
                                    title="Resources"
                                    placement="right"
                                >
                                    {resourcesEl}
                                </MenuTooltip>
                            )}
                        </NavLink>

                        <div
                            className={`navbar-menu-item ${
                                expandMenu ? " practices-section-expanded" : ""
                            }`}
                            onClick={() => {
                                // Track Logout
                                trackActivity(
                                    eventType.LOGOUT,
                                    eventName.LOGOUT,
                                    "Home >> Menu Bar >> Click on Logout"
                                );
                                handleLogout();
                            }}
                        >
                            {expandMenu ? (
                                <>
                                    {logoutComp}
                                    <div>Logout</div>
                                </>
                            ) : (
                                <MenuTooltip title="Logout" placement="right">
                                    {logoutComp}
                                </MenuTooltip>
                            )}
                        </div>
                        {sikkaAdmin && (
                            <div
                                className={`navbar-menu-item ${
                                    expandMenu
                                        ? "practices-section-expanded"
                                        : ""
                                }`}
                                onClick={handleSwitchAccount}
                            >
                                {expandMenu ? (
                                    <>
                                        {switchAccComp}
                                        <div>Switch Account</div>
                                    </>
                                ) : (
                                    <MenuTooltip
                                        title="Switch Account"
                                        placement="right"
                                    >
                                        {switchAccComp}
                                    </MenuTooltip>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {showVideoModal && (
                <IntroVideoModal
                    openModal={showVideoModal}
                    closeModal={() => setShowVideoModal(false)}
                />
            )}

            {openAdminModal && (
                <AdminModal
                    openModal={openAdminModal}
                    closeModal={() => setOpenAdminModal(false)}
                    login={proceedToSwitchAccountPage}
                    openModalFromNavBar={true}
                    loading={loading}
                    setLoading={setLoading}
                />
            )}
        </div>
    );
}

const mapStateToProps = (state) => ({
    userInfo: state.dataReducer.userInfo,
    sikkaAdmin: state.dataReducer.sikkaAdmin,
});

export default connect(mapStateToProps, { addDataToStore })(NavBar);
